<div
  class="floating-onboarding-widget"
  *ngIf="isVisible"
>
  <!-- Compact pill -->
  <div class="onboarding-widget-pill" *ngIf="!expanded">
    <button
      type="button"
      class="onboarding-widget-main"
      (click)="toggleExpanded()"
      [attr.aria-label]="'PROGRESS.WIDGET.EXPAND_ARIA' | translate"
      [attr.aria-expanded]="false"
    >
      <span
        class="onboarding-widget-ring"
        [style.--progress]="progress"
        aria-hidden="true"
      >
        <span class="onboarding-widget-ring-inner"></span>
      </span>
      <span class="onboarding-widget-percent">
        {{ 'PROGRESS.WIDGET.SETUP' | translate }} {{ progress }}%
      </span>
    </button>

    <button
      type="button"
      class="onboarding-widget-dismiss"
      (click)="dismiss($event)"
      [attr.aria-label]="'PROGRESS.WIDGET.DISMISS_ARIA' | translate"
    >
      <span>&times;</span>
    </button>
  </div>

  <!-- Expanded card -->
  <div
    class="onboarding-widget-card"
    *ngIf="expanded"
    role="region"
    [attr.aria-label]="'PROGRESS.WIDGET.TITLE' | translate"
  >
    <div class="onboarding-widget-header">
      <div>
        <div class="onboarding-widget-title">
          {{ 'PROGRESS.WIDGET.TITLE' | translate }}
        </div>
        <div class="onboarding-widget-subtitle">
          {{ progress }}%
        </div>
      </div>

      <div class="onboarding-widget-actions">
        <button
          type="button"
          class="onboarding-widget-icon-button"
          (click)="toggleExpanded()"
          [attr.aria-label]="'PROGRESS.WIDGET.COLLAPSE_ARIA' | translate"
        >
          <span>&minus;</span>
        </button>
        <button
          type="button"
          class="onboarding-widget-icon-button"
          (click)="dismiss($event)"
          [attr.aria-label]="'PROGRESS.WIDGET.DISMISS_ARIA' | translate"
        >
          <span>&times;</span>
        </button>
      </div>
    </div>

    <div class="onboarding-widget-progress-bar" aria-hidden="true">
      <div
        class="onboarding-widget-progress-bar-fill"
        [style.width.%]="progress"
      ></div>
    </div>

    <div class="onboarding-widget-steps">
      <button
        type="button"
        class="onboarding-widget-step"
        *ngFor="let milestone of milestones"
        [class.onboarding-widget-step--completed]="milestone.completed"
        [class.onboarding-widget-step--locked]="!milestone.completed && isMilestoneLocked(milestone)"
        [class.onboarding-widget-step--actionable]="!milestone.completed && !isMilestoneLocked(milestone)"
        [disabled]="milestone.completed || isMilestoneLocked(milestone)"
        [attr.aria-label]="('PROGRESS.MILESTONES.' + milestone.key + '.TITLE') | translate"
        (click)="handleMilestoneClick(milestone)"
      >
        <span class="onboarding-widget-step-status" aria-hidden="true">
          <span nz-icon *ngIf="milestone.completed" nzType="check-circle" nzTheme="fill"></span>
          <span nz-icon *ngIf="!milestone.completed && isMilestoneLocked(milestone)" nzType="lock"></span>
          <span nz-icon *ngIf="!milestone.completed && !isMilestoneLocked(milestone)" nzType="arrow-right"></span>
        </span>

        <span class="onboarding-widget-step-content">
          <span class="onboarding-widget-step-label">
            {{ ('PROGRESS.MILESTONES.' + milestone.key + '.TITLE') | translate }}
          </span>

          <span
            class="onboarding-widget-step-hint"
            *ngIf="!milestone.completed && isMilestoneLocked(milestone)"
          >
            {{ 'PROGRESS.WIDGET.LOCKED_HELPER' | translate }}
          </span>
        </span>
      </button>
    </div>

    <button
      type="button"
      class="onboarding-widget-continue"
      data-tour="setup-continue"
      [disabled]="!firstUnlockedIncompleteMilestone"
      (click)="handleContinueClick()"
    >
      {{ 'PROGRESS.WIDGET.CONTINUE' | translate }}
    </button>
  </div>
</div>
